import AxiosInstance from "../../../shared/utils/axios";
import {
  buildTrialInsightsParams,
  type TrialListFilterParams,
} from "../trialService";

/** Filters every trials-insights endpoint accepts — the `GET /trials` set. */
export interface TrialInsightsParams {
  orgId: string;
  farmId: string;
  search?: string;
  completionFilter?: string;
  filters?: TrialListFilterParams;
}

/** One slice of a bucketed aggregation. */
export interface InsightsDatum {
  /** Raw enum value from the API, e.g. "activated". Not display copy. */
  label: string;
  value: number;
}

/** Bucketed shape: GET /trials/insights/trials. */
export interface BucketInsightsResponse {
  retrieved_at: string;
  data: InsightsDatum[];
}

/**
 * Named-counts shape: GET /trials/insights/planned and
 * /trials/insights/yield-readiness return two named totals rather than a
 * slice list.
 */
export interface CountsInsightsResponse {
  retrieved_at: string;
  [field: string]: string | number;
}

export type AnyInsightsResponse =
  | BucketInsightsResponse
  | CountsInsightsResponse;

const queryFor = (params: TrialInsightsParams): string =>
  buildTrialInsightsParams(
    params.orgId,
    params.farmId,
    params.search ?? "",
    params.completionFilter ?? "",
    params.filters
  ).toString();

/**
 * Fetches one insights aggregation for the current trials filters.
 *
 * `path` comes from the chart config, so adding a card is a config entry
 * rather than a new service function.
 */
export const fetchTrialInsight = async (
  path: string,
  params: TrialInsightsParams
): Promise<AnyInsightsResponse> => {
  const response = await AxiosInstance.get(`${path}?${queryFor(params)}`);

  return response.data;
};
